<template>
<div>
  <div class="modeltop">
  {{school_type == 1 ? '学校登录' : '院系登录'}}
  </div>
  <div class="schoolbox">
    
    <!-- <p class="boxtitle">学校登录</p> -->
    <Form
      ref="loginForm"
      class="login-form"
      :model="form"
      :rules="rules"
      @keydown.enter.native="handleSubmit"
      style="width:100%"
    >
      <FormItem
        prop="username"
        class="sms-wrapper"
        style="font-size: 20;"
      >
        <Input
          v-model="form.username"
          placeholder="请输入用户名"
        />
      </FormItem>
      <FormItem prop="pwd" class="sms-wrapper">
        <Input
          v-model="form.pwd"
          type="password"
          placeholder="请输入密码"
        />
      </FormItem>
      <div class="forget-line">
        <span @click="handleForget" style="cursor: pointer">忘记密码？</span>
      </div>
      <Button
        @click="handleSubmit"
        size="large"
        type="primary"
        style="height:42px;margin-top: 15px; width: 100%;"
        >登录</Button
      >
    </Form>
  </div>
  </div>
</template>

<script>
// import { mapActions } from 'vuex'
import Cookies from 'js-cookie'
import { login } from '@/api/user'
import config from '@/config'
const { cookieExpires, cookie_key_user } = config

export default {
  name: 'Companylogin',
  data () {
    const validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入密码'))
      } else {
        callback()
      }
    }
    const validateUser = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入用户名'))
      } else {
        callback()
      }
    }
    return {
      form: {
        username: '',
        pwd: ''
      },
      msgflag: false,
      browserType:"",

      rules: {
        pwd: [{ validator: validatePass, trigger: 'blur' }],
        username: [{ validator: validateUser, trigger: 'blur' }]
      }
    }
  },
  props: ['school_type'],
  created(){
    this.browserTypeis()
  },

  methods: {
    // ...mapActions([
    //   'handleLogin',
    //   'getDashboard'
    // ]),
    // 学校登录成功清空  企业，学生的信息
    clearCookieData() {
      Cookies.remove('user_id')
      Cookies.remove('com_key_user')
      Cookies.remove('resume_data')
      sessionStorage.removeItem('studentInfo')
      sessionStorage.removeItem('resume_data')

      Cookies.remove('channel_userid')
      Cookies.remove('channel_channel_name')
    },
    // 设置cookies数据
    setCookieData(token,user_name,user_id,user_school,user_type,strategy) {
      Cookies.set(cookie_key_user, token, { expires: cookieExpires || 1 })
      Cookies.set('user_name', user_name, { expires: cookieExpires || 1 })
      Cookies.set('user_id', user_id, { expires: cookieExpires || 1 })
      Cookies.set('user_school', user_school, { expires: cookieExpires || 1 })
      Cookies.set('user_type', user_type, { expires: cookieExpires || 1 })
      Cookies.set('strategy', strategy, { expires: cookieExpires || 1 })
    },
    browserTypeis(){
      let userAgentstr = navigator.userAgent.toLocaleLowerCase(); 
      if (/safari/.test(userAgentstr) && !/chrome/.test(userAgentstr)) { 
            this.browserType = "Safari"; 
      }else if(userAgentstr.match(/tencenttraveler/) != null || userAgentstr.match(/qqbrowse/) != null){
            this.browserType = "QQ"; 
      }else if(userAgentstr.match(/msie/) != null || userAgentstr.match(/trident/) != null) { 
            this.browserType = "IE";
      } 

    },
    handleSubmit () {
      this.$refs.loginForm.validate((valid) => {
        if (valid) {
          this.$Spin.show()
          login({
            name: this.form.username,
            password: this.form.pwd
          }).then(res => {
            sessionStorage.setItem('userdata', JSON.stringify(res))
            if(res.apiStatus){
              this.clearCookieData()
              this.$emit('closeSchoolDialog')
              Cookies.set("login_type", 'school',{expires:14});
              this.setCookieData(String(res.user_id),this.form.username,String(res.user_id),String(res.school),String(res.user_type),String(res.strategy))
              if (res.faculty) {
                Cookies.set('faculty', String(res.faculty), { expires: cookieExpires || 1 })
              }
              this.userdata = {
                user_id: Number(res.user_id),
                school: res.school,
                user_type: Number(res.user_type)
              }
              if (Number(res.user_type) !== 0) {
                if(this.browserType == 'QQ' || this.browserType == 'IE' ||  this.browserType == 'Safari'){
                  window.location.href = `${window.location.origin}/school/#/lifeDecide`
                }else{
                  window.open(`${window.location.origin}/school/#/lifeDecide`)
                }
              } else {
                  if(this.browserType == 'QQ' || this.browserType == 'IE' ||  this.browserType == 'Safari'){
                    window.location.href = `${window.location.origin}/school/#/dashboard`
                  }else{
                    window.open(`${window.location.origin}/school/#/dashboard`)
                  }
              }
            }else{
              if (res.data.code === 20024 || res.data.code === 10003) {
                this.$Message.error('请输入正确的用户名和密码')
              } else {
                this.$Message.error(res.data.code + ' : ' + res.data.msg)
              }
            }
            this.$Spin.hide()
            // this.$emit('func1', this.msgflag)
          }, (err) => {
            this.$Spin.hide()
            if (err.code === 20024 || err.code === 10003) {
              this.$Message.error('请输入正确的用户名和密码')
            } else {
              this.$Message.error(err.code + ' : ' + err.msg)
            }
          })
        }
      })
    },
    handleForget () {
      const content = `        <div>
          <p>毕业申技术咨询</p>
          <p>微信：18618362798</p>
        <p>邮箱：info@applyoffer.com </p>
        <p>联系电话：021-66696957 </p>
        </div>`
      this.$Modal.info({
        title: '忘记密码, 请与我们联系',
        content: content
      })
    }
  }
}
</script>

<style scoped>
.schoolbox {
  width: 320px;
  height: 100%;
  margin: 30px auto;
}

.forget-line {
  text-align: right;
}

.boxtitle {
  font-size: 18px;
  color: #515a6e;
  text-align: center;
  font-weight: bold;
  margin: 20px 0;
}

.modeltop{
  height:56px;
  width:100%;
  border-radius: 8px 8px 0px 0px;
  background: #F4F7FE;
  font-size: 18px;
  font-weight: bold;
  color: #333333;
  text-align: center;
  line-height: 56px;
}
</style>

<style>
.schoolbox .ivu-input {
  height: 42px;
  width: 100%;
  background: #f6f7f9;
  border: 0;
  font-size: 14px;
  border-radius: 4px !important;
}

.schoolbox .ivu-form-item{
  margin-bottom:22px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/transferlogin/schoollogin.vue